<template>
  <section class="sentenceGroupComponent">
    <audio ref="ref_audio" controls @ended="overAudio">
      <source :src="currentVoiceUrl">
    </audio>
    <ul class="sentence-group-wraper">
      <li v-for="(item, index) in groupListFormat" :key="index" class="sentence-group-item">
        <div class="group-tit">
          <el-checkbox v-if="checkType === 'checkbox'" v-model="checkedArr" :label="item.id" :disabled="checkedArr.length >= 10">{{ item.groupName }}</el-checkbox>
          <el-radio v-else v-model="checkedArr" :label="item.id">{{ item.groupName }}</el-radio>
        </div>
        <div class="word-wraper">
          <div v-for="(wordItem, index2) in item.children" :key="index2" class="word-item" :class="{active: wordItem.id === currentWord.id}">
            <el-image :src="wordItem.imgUrl" fit="fit" @click="imgClick(wordItem)" />
            <el-button class="voice-icon" type="primary" circle @click="voiceClick(wordItem, 'sentence'+index+index2)">
              <i :class="'sentence'+index+index2 === currentIndex?'suonaAnimation':''" class="suonaIcon" />
            </el-button>
            <div class="bottom-bar">{{ wordItem.name }}</div>
          </div>
        </div>
      </li>
      <li v-if="groupListFormat.length === 0" style="text-align: center; margin-top: 50px;color: #828481;">暂无数据</li>
    </ul>
  </section>
</template>

<script>

// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  // model: {
  //   prop: 'checkedSentenceGroupIds',
  //   event: 'change'
  // },
  props: {
    checkType: {
      type: String,
      default: 'checkbox'
    },
    // groupType: {
    //   type: String,
    //   default: 'SENTENCE_PATTERN_GROUP_MEANS'
    // },
    checkedSentenceGroupIds: {
      type: Array,
      default: function () {
        return []
      }
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      currentIndex: -1,
      currentVoiceUrl: '',
      currentWord: {}
    }
  },
  computed: {
    checkedArr: {
      get() {
        return this.checkType === 'checkbox' ? this.checkedSentenceGroupIds : this.checkedSentenceGroupIds[0]
      },
      set(val) {
        this.$emit('update:checkedSentenceGroupIds', this.checkType === 'checkbox' ? val : [val])
      }
    },

    groupListFormat () {
      const arr = []

      for (let i = 0; i < this.groupList.length; i++) {
        arr.push({
          id: this.groupList[i].id,
          groupName: this.groupList[i].wordName,
          children: []
        })

        for (const item2 of this.groupList[i].basicMeansResList) {
          arr[i].children.push({
            id: item2.id,
            imgUrl: item2.cardChartPath,
            name: item2.wordName,
            voice: item2.pronunciationPath,
            mouthShapePath: item2.mouthShapePath
          })
        }
      }
      // if (this.groupType === 'SENTENCE_PATTERN_GROUP_MEANS') {
      //   for (let i = 0; i < this.groupList.length; i++) {
      //     arr.push({
      //       id: this.groupList[i].id,
      //       groupName: this.groupList[i].wordName,
      //       children: []
      //     })

      //     for (const item2 of this.groupList[i].basicMeansResList) {
      //       arr[i].children.push({
      //         id: item2.id,
      //         imgUrl: item2.cardChartPath,
      //         name: item2.wordName,
      //         voice: item2.pronunciationPath
      //       })
      //     }
      //   }
      // } else if (this.groupType === 'NATURAL_SPELLING_MEANS') {
      //   for (let i = 0; i < this.groupList.length; i++) {
      //     arr.push({
      //       id: this.groupList[i].id,
      //       groupName: this.groupList[i].wordName,
      //       children: []
      //     })

      //     for (const item2 of this.groupList[i].basicMeansResList) {
      //       arr[i].children.push({
      //         id: item2.id,
      //         imgUrl: item2.cardChartPath,
      //         name: item2.wordName,
      //         voice: item2.pronunciationPath,
      //         mouthShapePath: item2.mouthShapePath
      //       })
      //     }
      //   }
      // } else if (this.groupType === 'HIGH_FREQUENCY_MEANS') {
      //   for (let i = 0; i < this.groupList.length; i++) {
      //     arr.push({
      //       id: this.groupList[i].id,
      //       groupName: this.groupList[i].wordName,
      //       children: []
      //     })

      //     for (const item2 of this.groupList[i].basicMeansResList) {
      //       arr[i].children.push({
      //         id: item2.id,
      //         imgUrl: item2.cardChartPath,
      //         name: item2.wordName,
      //         voice: item2.pronunciationPath
      //       })
      //     }
      //   }
      // }
      return arr
    }
  },
  watch: {

  },
  created () {

  },
  methods: {
    imgClick (item) {
      this.currentWord = item
      this.$store.commit('courseStep/SET_currentClickData', item)
      console.log(item)
    },
    voiceClick (item, index) {
      this.currentIndex = index
      this.currentVoiceUrl = item.voice
      this.$nextTick(() => {
        this.$refs.ref_audio.load()
        this.$refs.ref_audio.play()
      })
    },
    overAudio() {
      this.currentIndex = -1
    }
  }
}
</script>

<style lang='scss'>
.sentenceGroupComponent{
  .sentence-group-wraper{
    .sentence-group-item{
      margin-bottom: 20px;
      .group-tit{
        margin-bottom: 20px;
      }
      .word-wraper{
        overflow-x: auto;
        // white-space: nowrap;
        .word-item{
          display: inline-block;
          position: relative;
          margin: 0 8px 16px 8px;
          padding: 16px;
          background-color: #F7F6F4;
          border-radius: 12px;
          transition: all 0.3s;
          width: 168px;
          border:2px solid transparent;
          &.active{
            border-color: #FCDA6F;
          }
          .el-image{
            cursor: pointer;
            width: 136px;height: 126px;
            border-radius: 8px;
            margin-bottom: 15px;
            background-color: white;
          }
          .voice-icon{
            position: absolute;
            right: 22px;
            top: 22px;
            padding: 7px;
            box-shadow: 0px 3px 6px rgba(248, 212, 91, 0.5);
            cursor: pointer;
            .suonaIcon{
              width:13px;
              height:11px;
              display: inline-block;
              background-image:url('../../../../assets/images/suona3.png');
                &.suonaAnimation{
                  animation:myfirst 1s infinite;
                // /* Safari and Chrome */
                -webkit-animation:myfirst 1s infinite;
                }
            }
            @keyframes myfirst
            {
            0%   {background-image:url('../../../../assets/images/suona1.png');}
            50%  {background-image:url('../../../../assets/images/suona2.png');}
            100% {background-image:url('../../../../assets/images/suona3.png')}
            }

            @-webkit-keyframes myfirst /* Safari and Chrome */
            {
            0%   {background-image:url('../../../../assets/images/suona1.png');}
            50%  {background-image:url('../../../../assets/images/suona2.png');}
            100% {background-image:url('../../../../assets/images/suona3.png')}
            }
          }
          .bottom-bar{
            line-height: 16px;
            height: 32px;
            color: #45433D;font-size: 14px;
            text-align: center;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
            .el-checkbox{
              display: inline-flex;
              justify-content: center;
              align-items: center;
            }
            .el-checkbox__label{
              max-width: 90px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }

    }
  }
}
</style>
